export enum EEslTemplateElementType {
    Text,
    MultilineText,
    Image,
    Line,
    Rectangle,
    Circle,
    LastCleaningDatetime,
    ServiceRequestQRCode,
}
